// Where each kind of signed-in user belongs. Used by both headers (logo,
// "My dashboard") and by the router (opening /login while signed in), so
// they always agree.
import { UsersStates } from "../store/Storetypes";

// Signing out leaves an empty object ({}) as the user, so look for an id
export function isSignedIn(usersState) {
  const user = usersState && usersState[UsersStates.USER];
  return !!(user && (user.uid || user.id));
}

// Route name of the person's dashboard, or null for a signed-in user
// without a known role
export function dashboardRouteFor(usersState) {
  if (!isSignedIn(usersState)) return null;
  if (usersState[UsersStates.IS_ADMIN]) return "admin-dashboard";
  if (usersState[UsersStates.IS_VENDOR]) return "vendor-dashboard";
  if (usersState[UsersStates.IS_EMPLOYEE]) return "guider-upcoming-activities";
  if (usersState[UsersStates.IS_COMPANY]) return "company-dashboard";
  if (usersState[UsersStates.IS_AFFILIATE]) return "affiliate-dashboard";
  if (usersState[UsersStates.IS_PRIVATE_GUIDE]) return "guide-portal";
  return null;
}
